<template>
  <div id="document-list-vue" class="fr-view">
    <h4>Documents</h4>
    
    <!-- filter -->
    <div class="filter-area" data-content-type="document">
      <section class="filter-view">
        <div class="row">
          <div class="col-12">
            <nav class="filter-menu" id="filter-menu-bar">
              <div class="filter-menu-dropdowns d-flex justify-content-left align-items-center">
                <div class="filtering-dropdown font-weight-bold"><slot name="hl-doclist-typefilter"></slot>
                  <div class="filtering-dropdown-container">
                    <button @click="toggle('showType')" class="filtering-dropdown-container-btn">{{selectedTypeText}}<span class="icon-arrow-down"></span></button>
                    <ul v-show="showType" class="filtering-dropdown-list list-unstyled">
                      <li @click="setType(null, defaultText)" :value="defaultText" :key="defaultText" tabindex="0" aria-role="option" aria-live="polite" aria-label="" class="filtering-dropdown-list-item">
                        <span class="filtering-dropdown-list-item-text">(<slot name="hl-doclist-showall"></slot>)</span>
                      </li>
                      <li @click="setType(type, type)" v-for="type in filteredDocumentListType" :value="type" :key="type" tabindex="0" aria-role="option" aria-live="polite" aria-label="" class="filtering-dropdown-list-item">
                        <span class="filtering-dropdown-list-item-text">{{type}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="filtering-dropdown font-weight-bold"><slot name="hl-doclist-yearfilter"></slot>
                  <div class="filtering-dropdown-container">
                    <button @click="toggle('showYear')" class="filtering-dropdown-container-btn">{{selectedYearText}}<span class="icon-arrow-down"></span></button>
                    <ul v-show="showYear" class="filtering-dropdown-list list-unstyled">
                      <li @click="setYear(null, defaultText)" :value="defaultText" :key="defaultText" tabindex="0" aria-role="option" aria-live="polite" aria-label="" class="filtering-dropdown-list-item">
                        <span class="filtering-dropdown-list-item-text">(<slot name="hl-doclist-showall"></slot>)</span>
                      </li>
                      <li @click="setYear(year, year)" v-for="year in filteredDocumentListYear" :value="year" :key="year" tabindex="0" aria-role="option" aria-live="polite" aria-label="" class="filtering-dropdown-list-item">
                        <span class="filtering-dropdown-list-item-text">{{year}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="filtering-dropdown font-weight-bold"><slot name="hl-doclist-shareclassfilter"></slot>
                  <div class="filtering-dropdown-container">
                    <button @click="toggle('showShareClass')" class="filtering-dropdown-container-btn">{{selectedShareClassText}}<span class="icon-arrow-down"></span></button>
                    <ul v-show="showShareClass" class="filtering-dropdown-list list-unstyled">
                      <li @click="setShareClass(null, defaultText)" :value="defaultText" :key="defaultText" tabindex="0" aria-role="option" aria-live="polite" aria-label="" class="filtering-dropdown-list-item">
                        <span class="filtering-dropdown-list-item-text">(<slot name="hl-doclist-showall"></slot>)</span>
                      </li>
                      <li @click="setShareClass(shareClass, shareClass)" v-for="shareClass in filteredDocumentListShareClass" :value="shareClass" :key="shareClass" tabindex="0" aria-role="option" aria-live="polite" aria-label="" class="filtering-dropdown-list-item">
                        <span class="filtering-dropdown-list-item-text">{{shareClass}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <button @click="clearAllFilters(defaultText)" class="no-border blue-link filter-menu-clear-button"><slot name="hl-doclist-clearfilters"></slot></button>
                <!-- <button class="hl-button filter-menu-apply-button">Apply Filters</button> -->
              </div>
              <div class="d-md-flex mb-4">
                <div class="filter-menu-tags w-100">
                  <ul class="list-unstyled mb-0"></ul>
                </div>
              </div>
              <div class="filter-menu-mobile-bar background-is-white py-3 px-4"></div>
            </nav>
          </div>
        </div>
      </section>
    </div>
    <!-- end filter -->
  
    <div class="document-list-table-container">
      <table class="document-list-table fr-alternate-rows" style="width: 100%;">
        <thead>
          <tr class="fr-highlighted" style="background-color: rgb(1, 46, 76); vertical-align: top; width: 25.0369%;">
            <!-- Load Table Columns -->
            <th>
              <p style="color:white;"><slot name="hl-doclist-nameheader"></slot></p>
            </th>
            <th>
              <p style="color:white;"><slot name="hl-doclist-dateheader"></slot></p>
            </th>
            <th>
              <p style="color:white;"><slot name="hl-doclist-shareclassheader"></slot></p>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <!-- Load Data -->
          <tr v-for="entry in pagedDocumentListData">
            <td class="document-name-field">
              <span>{{entry['docName']}}</span>
            </td>
            <td>
              <span>{{entry['itemDate']}}</span>
            </td>
            <td>
              <span>{{entry['shareClass']}}</span>
            </td>
            <td class="document-download">
              <a v-bind:href="entry['downloadLink']" target="_blank" :download="entry['forceDownload']"><slot name="hl-doclist-downloadbutton"></slot></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 font-weight-bold text-center text-md-left">{{pagerCountText}}</div>
        <div class="col-md-6 text-center text-md-right">
          <div class="container-fluid">
            <div class="row pager-container">
              <div class="pager-label font-weight-bold"><slot name="hl-doclist-page"></slot></div>
              <ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination pagination-md">
                <li v-for="index in totalFilteredPages" role="none presentation" :class="{'page-item': currentPage != index, 'page-item active': currentPage == index}">
                  <a @click.prevent="currentPage = index" role="menuitemradio" tabindex="0" :aria-label="'Goto page ' + index" aria-checked="true" :aria-posinset="index" :aria-setsize="totalFilteredPages" href="#" target="_self" class="page-link">{{index}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                defaultText: "",
                showType: false,
                showYear: false,
                showShareClass: false,
                selectedType: null,
                selectedYear: null,
                selectedShareClass: null,
                selectedTypeText: "",
                selectedYearText: "",
                selectedShareClassText: "",
                pageOfItems: [],
                docListGridData: [],
                filterItemCount: 0,
                totalFilteredPages: 0,
                filteredDocumentListType: [],
                filteredDocumentListYear: [],
                filteredDocumentListShareClass: [],
                currentPage: 1,
                documentListSize: DocumentListSize
            };
        },
        created() {
            this.docListGridData = DocumentListGridData;
            this.filterItemCount = this.docListGridData.length;
            this.totalFilteredPages = this.calcTotalPages(this.filterItemCount, this.documentListSize)
            this.filteredDocumentListType = DocumentListDataTypesFilter;
            this.filteredDocumentListYear = DocumentListYearFilter;
            this.filteredDocumentListShareClass = DocumentListShareClassFilter;
        },
        methods: {
            toggle: function (choice) {
                if (choice == "showType") this.showType = !this.showType; else this.showType = false;
                if (choice == "showYear") this.showYear = !this.showYear; else this.showYear = false;
                if (choice == "showShareClass") this.showShareClass = !this.showShareClass; else this.showShareClass = false;
            },
            setType: function (value, text) {
                this.selectedType = value;
                this.selectedTypeText = text;
                this.showType = false;
            },
            setYear: function (value, text) {
                this.selectedYear = value;
                this.selectedYearText = text;
                this.showYear = false;
            },
            setShareClass: function (value, text) {
                this.selectedShareClass = value;
                this.selectedShareClassText = text;
                this.showShareClass = false;
            },
            clearAllFilters: function (text) {
                this.selectedType = null;
                this.selectedTypeText = text;
                this.showType = false;
                this.selectedYear = null;
                this.selectedYearText = text;
                this.showYear = false;
                this.selectedShareClass = null;
                this.selectedShareClassText = text;
                this.showShareClass = false;
            },
            calcTotalPages: function (itemCount, pageSize) {
                //we suppose that if we have 0 items we want 0 pages
                return Math.ceil(itemCount / pageSize);
            }
        },
        computed: {
            pagerCountText() {
                //Basically, String.Format(format, filterItemCount, totalRowsDocumentListData). Uses {0}, {1}, etc. If you need more parameters later, add them to 'args'
                var format = this.$slots['hl-doclist-pagercountformat'][0].text.trim();
                var args = new Array(this.filterItemCount, this.totalRowsDocumentListData);
                return format.replace(/{(\d+)}/g, function (match, number) {
                    return typeof args[number] != 'undefined' ? args[number] : match;
                });
            },
            pagedDocumentListData() {
                var items = [];
                items = this.filteredDocumentListData;

                // Return just page of items needed
                return items.slice(
                    (this.currentPage - 1) * this.documentListSize,
                    this.currentPage * this.documentListSize
                );
            },
            totalRowsDocumentListData() {
                return this.docListGridData.length;
            },
            filteredDocumentListData() {
                function dropdownIsDefault(value, defaultText) {
                    return value == null || value == defaultText;
                }

                //use new page size variable
                var allData = this.docListGridData;

                var filteredData = this.docListGridData;

                //AND logic
                if (
                    !dropdownIsDefault(this.selectedType, this.defaultText) ||
                    !dropdownIsDefault(this.selectedYear, this.defaultText) ||
                    !dropdownIsDefault(this.selectedShareClass, this.defaultText)
                ) {
                    if (!dropdownIsDefault(this.selectedType, this.defaultText)) {
                        filteredData = allData.filter(
                            (item) => item.docType === this.selectedType
                        );
                    }

                    if (!dropdownIsDefault(this.selectedYear, this.defaultText)) {
                        filteredData = filteredData.filter(
                            (item) => item.itemDateYear === this.selectedYear
                        );
                    }

                    if (!dropdownIsDefault(this.selectedShareClass, this.defaultText)) {
                        filteredData = filteredData.filter(
                            (item) =>
                                item.shareClass === this.selectedShareClass
                        );
                    }

                    this.filterItemCount = filteredData.length;
                    this.totalFilteredPages = this.calcTotalPages(this.filterItemCount, this.documentListSize);
                    return filteredData;
                }
                else {
                    this.filterItemCount = allData.length;
                    this.totalFilteredPages = this.calcTotalPages(this.filterItemCount, this.documentListSize);
                    return allData;
                }
            }
        }
    }
</script>

<style lang="scss">
#document-list-vue
{
  padding: 30px 0;

  section.filter-view
  {
    padding: 15px;
  }

  .filter-menu-dropdowns
  {
    gap: 1em;
    margin-bottom: 0;
    padding: 0;
  }
  
  .filtering-dropdown 
  {
    margin-right: 0;

    &:focus-within
    {
      outline: 0;
    }

    .filtering-dropdown-container
    {
      border: 1px solid #cccccc;
    }
  }
  
  .filtering-dropdown-list-item:before
  {
    content: none;
  }
  
  .document-list-table-container
  {
    width: 100%;
    overflow-x: auto;

    .document-list-table
    {
      margin-bottom: 20px;
    
      th
      {
        text-transform: uppercase;
        font-weight: normal;
      }
      
      td
      {
        font-size: 14px;
        color: #222529;
        width: 16.6%;
        width: calc(50% / 3);
        
        white-space: nowrap;

        &.document-name-field
        {
          width: 50%;
          white-space: normal;
        }

        &.document-download
        {
          text-align: end;
          padding-right: 20px;
          
          a
          {
            font-weight: bold;
            text-decoration: underline;
            color: #005388;
          }
        }
      }
    }
  }

  .pager-container 
  {
    justify-content: center;
    
    ul.pagination
    {
      padding-left: 5px;
      line-height: 24px;
    }
    
    .page-item
    { 
      &.disabled 
      {
        display: none;
      }
      
      &::before 
      {
        content: none !important;
      }
      
      a
      {
        color: #005388;
        border: none;
        padding: 0 5px;

        &:hover
        {
          color: blue;
          border: none;
          text-decoration: underline;
          background-color: transparent;
          padding: 0 5px;
        }
      }
      &.active a
      {
        border: none;
        text-decoration: underline;
        background-color: transparent;
        padding: 0 5px;
      }
    }
  }
}

@include respond-above(md)
{
  #document-list-vue
  {
    padding-left: 30px;
    padding-right: 30px;

    .document-list-table-container
    {
      .document-list-table
      {
        td
        {
          font-size: 18px;
        }
      }
    }

    .pager-container 
    {
      justify-content: end;
    }
  }
}
</style>